module.exports = __webpack_public_path__ + "img/ic-receipt.27378abf.png";